    <script type="text/ecmascript-6">
    import DesignerQuestionHardwareLock from "../DesignerQuestionHardwareLock.vue";
    import SynsealQuestion from "../mixin/synseal/Question.vue";

    export default {
        mixins: [
            DesignerQuestionHardwareLock,
            SynsealQuestion,
        ],
    }
</script>
